/**
 * Preview the loyalty points a buyer will earn for paying `amount` units of
 * currency under the current `pointsPer100` rate. Mirrors the BE rule in
 * `LoyaltyService.awardPointsForPayment` (procurtal-backend) so the checkout
 * preview can't drift from what is actually awarded after payment.
 *
 * Negative or non-finite amounts return 0 — checkout shouldn't render an
 * "earn -3 points" line under any circumstance.
 */
export function calculateEarnedPoints(amount: number, pointsPer100: number | undefined | null): number {
  if (!Number.isFinite(amount) || amount <= 0) return 0;
  const rate = pointsPer100 ?? 0;
  if (rate <= 0) return 0;
  return Math.floor((amount / 100) * rate);
}
